const playerHeight = 56;
const playerHeightSmall = 88;
const defaultMargin = 12;
const sidePaddingSmall = 16;
const sidePaddingMed = 32;
const sidePaddingRightScrollbarMed = 45;
const sidePadding = defaultMargin * 2;
const formItemFontSize = 15;
const formItemHeight = 40;
const formItemBorderRadius = 3;
const leftSideWidth = 216;
const rightSideLeftPadding = 4;
const browserMaxScrollbarOffset = 17;
const rightSideWidth = 300;
const rightSideWidthPadding =
  rightSideWidth + rightSideLeftPadding + browserMaxScrollbarOffset;
const mainContentMaxWidth = 1833;
const headerHeight = 65;
const contentAreaSpacing = 18;
const mainContentMaxWidthClosedRight = mainContentMaxWidth - leftSideWidth;
const mainContentMaxWidthOpenSidebars =
  mainContentMaxWidth -
  (leftSideWidth + rightSideWidth + browserMaxScrollbarOffset);
// font stacks from https://gist.github.com/gpessia/8595729

const primaryFont = [
  'Calibre-Regular',
  'TeXGyreHerosRegular',
  'Helvetica',
  'Tahoma',
  'Geneva',
  'Arial',
  'sans-serif',
];

const localFont = ['Helvetica', 'Tahoma', 'Geneva', 'Arial', 'sans-serif'];

const primaryFontBold = ['Calibre-Bold', '"TeXGyreHerosBold"', ...primaryFont];

const primaryFontStr = primaryFont.join(', ');
const localFrontStr = localFont.join(', ');

const primaryFontLightStr = [
  'HelveticaNeueLight',
  'HelveticaNeue-Light',
  '"Helvetica Neue Light"',
  ...primaryFont,
].join(', ');

const primaryFontThinStr = [
  'HelveticaNeueThin',
  'HelveticaNeue-Thin',
  '"Helvetica Neue Thin"',
  ...primaryFont,
].join(', ');

const primaryFontBoldStr = [...primaryFontBold, ...primaryFont].join(', ');

const primaryFontMedStr = ['Calibre-Medium', ...primaryFont];

const primaryFontSemiBoldStr = ['Calibre-Semibold', ...primaryFont];

const primaryFontHeaderStr = ['GT-Pressura-Ti-Regular', ...primaryFont].join(
  ', ',
);

const auxiliaryFontHeaderStr = ['Roboto', 'sans-serif'].join(', ');

const primaryFontHeaderBoldStr = [
  'GT-Pressura-Ti-Bold',
  ...primaryFontBold,
].join(', ');

module.exports = {
  // COLORS
  // teals
  '--primary-color-1': '#36b4a7',
  '--primary-color-2': '#28877d',
  '--t-sharp': '#14d8cc',

  '--primary-color-1-hover': '#626680',
  '--ink-extra-light': '#606376',
  '--ink-light': '#4b4f6b',
  '--ink-med': '#333751',
  '--ink-med-dark': '#4a4d64',
  '--ink-dark': '#0b0e24',
  '--dark-blue': '#1c1e3e',

  '--content-area-background-color-hex': '#FFFFFF',

  // orange
  '--orange-1': '#fec25a',

  // black to grey
  '--secondary-color-1': '#37444e', // dark blue
  '--secondary-color-2': '#a7a7a7',
  '--secondary-color-3': '#7c7c7c',
  '--secondary-color-4': '#858585',
  '--secondary-color-5': '#1c203c', // ink
  '--secondary-color-6': '#a8a8a8',
  '--secondary-color-7': '#33364F', // light ink
  '--ink-11': '#131730',

  '--black': '#000000', // black
  '--sky': '#7fcfec',
  '--sky-hover': '#91dcf7',
  '--sky-active': '#aae3f8',

  // greys
  '--grey-1': '#9d9ea9',
  '--grey-2': '#eeefee',
  '--grey-3': '#f6f8f6',
  '--grey-4': '#dadada',
  '--grey-5': '#F2F2F5',
  '--grey-6': '#8A8D9E',
  '--text-grey': '#6e6e84',
  '--tunein-gray': '#fafafa',
  '--tunein-gray-border-light': '#dbdbdb',
  '--tunein-gray-active': '#f8f8f8',
  '--tunein-container-item-border-gray': 'rgba(186, 186, 186, 0.25)',
  '--modal-input-color': '#F2F2F5',
  '--grey-hover': '#f7f8f6',

  // Numbered Lists
  '--index-number-light': '#ababab',
  '--numbered-element-subtitle-color': '#a4a6b1',
  '--numbered-element-border-color': '#ebebeb',

  // Currently used in:
  // - PillButton
  // - Left sidebar background
  // footer social icons bg
  '--tunein-gray-2': '#e6e6e6',

  // Currently used in:
  // - PillButton
  '--tunein-gray-3': '#efefef',
  '--white': '#FFFFFF',

  '--compact-gray': '#f1f1f1',

  '--border-color': '#c8c8c8',
  '--border-light-color': '#d6d6d6',
  '--light-icon-color': '#AFAFAF',

  '--darken-hover-color': 'rgba(0, 0, 0, 0.15)',

  '--bg-color-1': '#2c9a8f',

  '--premium-gold': '#d9962f',
  '--premium-gold-2': '#e49a24',
  '--premium-gold-light': '#fec25a',
  '--premium-gold-darken': '#b47a21',
  '--gold-light': '#fecb72',
  '--paypal-gold': '#ffc439',

  // some red
  '--tunein-coral': '#fd685f',
  '--tunein-coral-light': '#fd8c85',
  '--tunein-coral-hover': '#ff8b85',
  '--tunein-coral-soft': '#f26961',
  '--error-color': '#d0021b',
  '--error-color-2': '#c40909',
  '--error-color-light': '#e07577',

  '--dark-sub-text': '#9b9b9b',

  '--off-white': '#F4F4F6',

  '--divider': '#e6e6e6',

  '--facebook-color': '#3b5998',
  '--facebook-color-hover': '#344c80',
  '--facebook-color-active': '#2f436c',
  '--upsell-button-color': '#000000',
  '--upsell-button-hover': '#4c4c4c',

  '--lighter-hover-luminosity-value': -0.2,
  '--lighter-disabled-opacity-value': 0.4,
  '--dialog-default-opacity-value': '0.54',

  '--home-page-header-menu-color': '#303030',
  '--home-page-header-menu-hover': '#575757',

  '--user-header-image-border': '#e3e4e3',
  '--user-header-ink-medium': '#33364f',
  '--user-header-ink-dark': '#1b203b',

  // FONTS
  '--primary-font': primaryFontStr,
  '--local-font': localFrontStr,
  '--primary-font-bold': primaryFontBoldStr,
  '--primary-font-med': primaryFontMedStr,
  '--primary-font-light': primaryFontLightStr,
  '--primary-font-thin': primaryFontThinStr,
  '--primary-font-semi-bold': primaryFontSemiBoldStr,
  '--primary-font-header-bold': primaryFontHeaderBoldStr,
  '--primary-font-header': primaryFontHeaderStr,
  '--auxiliary-font-header': auxiliaryFontHeaderStr,

  // FONT SIZES
  '--secondary-font-size': '16px',
  '--more-info-font-size': 16,
  '--more-info-letter-spacing': 0.7,
  '--text-letter-spacing': '0.7px',
  '--primary-button-letter-spacing': '3px',
  '--container-title-font-size': '24px',
  '--container-subtitle-font-size': '16px',
  '--auth-label-font-size': '16px',

  '--guide-title-font-size': '16px',
  '--guide-title-line-height': '16px',
  '--guide-sub-font-size': '12px',
  '--guide-sub-line-height': '15px',

  '--list-item-title-font-size': '18px',
  '--list-item-title-line-height': '20px',
  '--list-item-sub-font-size': '16px',
  '--list-item-sub-line-height': '19px',

  '--default-button-font-size': '16px',
  '--default-button-icon-size': 12,
  '--small-button-font-size': '14px',
  '--small-label-font-size': '11px',

  '--info-font-size': '16px',

  '--form-item-font-size': formItemFontSize,
  '--form-item-font-size-px': `${formItemFontSize}px`,
  '--form-label-font-size': '15px',

  '--page-title-font-size': '40px',
  '--page-title-sub-heading-size': '21px',

  // HEIGHTS/WIDTHS
  // playerHeight is still used in a regular css file so need the px
  '--browser-max-scrollbar-width': browserMaxScrollbarOffset,
  '--player-height': `${playerHeight}px`,
  '--player-height-small': `${playerHeightSmall}px`,

  '--site-header-height': `${headerHeight}px`,
  '--sidebar-bottom-padding': `${playerHeight + 60}px`,
  '--sidebar-bottom-padding-small': `${playerHeightSmall + 60}px`,
  '--rightSide-left-padding': rightSideLeftPadding,
  '--rightSide-width': rightSideWidth + rightSideLeftPadding,
  '--leftSide-width': leftSideWidth,

  // these are specifically for the padding around the main content
  '--rightSide-width-padding-px': `${rightSideWidthPadding}px`,
  '--leftSide-width-px': `${leftSideWidth}px`,

  '--content-area-spacing': `${contentAreaSpacing}px`,

  // right side ad display drawer
  '--right-side-top-padding': `${headerHeight + contentAreaSpacing}px`,
  '--right-side-right-padding': 0,
  '--right-side-bottom-padding': '20px',

  '--default-margin': defaultMargin,
  '--extra-margin': defaultMargin * 2,

  '--content-max-width-px': `${mainContentMaxWidthOpenSidebars}px`,
  '--content-max-width-closedright-px': `${mainContentMaxWidthClosedRight}px`,

  '--content-side-padding-px': `${sidePadding}px`,
  '--content-side-padding-px-small': `${sidePaddingSmall}px`,
  '--content-side-padding-px-med': `${sidePaddingMed}px`,
  '--content-side-padding-right-scrollbar-px-med': `${sidePaddingRightScrollbarMed}px`,

  '--default-margin-px': `${defaultMargin}px`,
  '--field-margin': '20px',
  '--header-margin': '36px',

  // Spacing below container item group items
  '--gallery-item-side-padding-initial-px': '4px',
  '--gallery-item-side-padding-small-px': '8px',
  '--brick-tile-bottom-padding-px': '0px',

  '--auth-dialog-z-index': 1700,
  '--now-playing-ad-z-index': 1600,
  '--top-z-index': 1500,
  '--above-top-z-index': 1550,
  '--app-z-index': 1400,

  // Borders

  '--tile-border-radius': 4,

  // forms
  '--form-item-height': formItemHeight,
  '--form-item-height-px': `${formItemHeight}px`,
  '--form-item-border-radius': formItemBorderRadius,
  '--form-item-border-radius-px': `${formItemBorderRadius}px`,
  '--form-max-width-px': '624px',
  '--form-title-font-color': 'black',
  '--form-title-font-size-lg': '42px',

  '--small-form-item-height': '25px',

  '--hover-lum-setting': '15%',
  '--header-user-thumbnail-size': '88px',
  '--header-thumbnail-size': '100px',
  '--header-thumbnail-size-160': '160px',

  '--padding-small': '18px',
  '--padding-medium': '24px',
  '--search-bar-width': '287px',
  '--compact-container-padding': '21px',

  '--small-button-height': '27px',
  '--regular-button-height': '36px',
  '--large-button-height': '43px',

  '--content-sub-header-spacing': '12px',

  '--container-item-margin-bottom': '40px',

  // TRANSITIONS/TRANFORMS
  '--base-transition': 'all 0.2s ease 0ms',

  '--zdepth1-box-shadow':
    '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.12)',
  '--zdepth2-box-shadow':
    '0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23)',
  '--zdepth3-box-shadow':
    '0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23)',

  standardMuiZDepth: 3,

  '--landing-search-offset': '48px',
  '--landing-max-width': '1120px',
  '--landing-border-radius': '3px',

  // top banner height
  '--top-banner-height': '64px',

  // used in landing.css and optout.css
  '--main-nav-links-margin-left': '32px',
  '--main-nav-links-header-button-margin-right': '30px',
  '--main-nav-links-header-button-width': '111px',

  '--tall-page-header-content-padding': '20px',
  '--tall-page-header-content-padding-large': '35px',
  '--auth-form-max-width': '775px',
};
